/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkQuarterValidation,
  convertQuatreManufacturer,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import moment from 'moment';

import { handleErrorMessages, setNewCmsMatRowData } from '../../store/actions';
import {
  BOTH_CODE_ERR,
  DUP_CODE,
  SPEC_OR_GEN_CODE_REQUIRED,
} from '../constantData';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

export default (props) => {
  const dispatch = useDispatch();
  const resultData = useSelector(
    (state) => state.sharedState.CmsReducer.matDrugListFromStore
  );
  const editedData = useSelector(
    (state) => state.sharedState.CmsReducer.editedData
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.CmsReducer?.errorMessagesInRedux;
  });
  const { data, id, ariaLabel, label, isEnablebyRole } = props;
  const { colId } = props.column;
  let rowIndex = 0;
  if (resultData && resultData.length > 0) {
    rowIndex = resultData.findIndex((x) => {
      return x.id === data.id;
    });
  } // handing on change text boxes event
  const handleChange = (e) => {
    const newObj = [...resultData];
    props.node.setDataValue(colId, e.target.value);
    newObj[rowIndex].colId = e.target?.value;
    newObj[rowIndex].addEdit = true;
    dispatch(setNewCmsMatRowData(newObj));
  };

  const handleOnBlurEvent = (value) => {
    const newObj = [...(resultData || [])];
    const row = newObj[rowIndex] || (newObj[rowIndex] = {});

    /* ---------- FIELD ALIASING ---------- */
    const aliasWrite = (r, field, val) => {
      r[field] = val;
      if (field === 'startQtr') r.startQuarter = val;
      if (field === 'startQuarter') r.startQtr = val;
      if (field === 'endQtr') r.endQuarter = val;
      if (field === 'endQuarter') r.endQtr = val;
    };
    if (colId) aliasWrite(row, colId, value);

    const keyFor = (f) => `${f}${rowIndex}`;
    const normalize = (v) => (v ?? '').toString().trim().toLowerCase();

    const getStart = (r) => r?.startQtr ?? r?.startQuarter;
    const getEnd = (r) => r?.endQtr ?? r?.endQuarter;

    /* ---------- CLEAR EXISTING ROW ERRORS ---------- */
    const clearRowErrors = (errs) =>
      (errs || []).filter((e) => {
        const isThisRow =
          e.fieldName === keyFor('startQtr') ||
          e.fieldName === keyFor('endQtr') ||
          e.fieldName === keyFor('specTheraCode') ||
          e.fieldName === keyFor('genCodeNum');

        const isOurType =
          e.errorType === 'startQtrRequired' ||
          e.errorType === 'invalidQuarterFormat' ||
          e.errorType === 'SPEC_OR_GEN_CODE_REQUIRED' ||
          e.errorType === 'BOTH_CODE_ERR' ||
          e.errorType === 'DUP_CODE';

        return !(isThisRow && isOurType);
      });

    const dedupeErrors = (errs) => {
      const seen = new Set();
      return (errs || []).filter((e) => {
        const k = `${e.fieldName}|${e.errorType}|${e.message}`;
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      });
    };

    let localErr = clearRowErrors(errorMessagesFromRedux);

    /* ---------- RESET FLAGS ---------- */
    row.startQtrErr = false;
    row.endQtrErr = false;
    row.specTheraCodeErr = false;
    row.genCodeNumErr = false;

    /* ---------- START QUARTER VALIDATION ---------- */
    const startQ = getStart(row);
    if (!startQ || !checkQuarterValidation(startQ)) {
      row.startQtrErr = true;
      localErr.push({
        fieldName: keyFor('startQtr'),
        errorType: 'invalidQuarterFormat',
        message: `${constantMessageData.CONTRACT_START_QUARTER_FORMAT_ERROR} #${
          rowIndex + 1
        }.`,
      });
      dispatch(setNewCmsMatRowData(newObj));
      dispatch(handleErrorMessages(dedupeErrors(localErr)));
      return;
    }

    /* ---------- END QUARTER FORMAT (OPTIONAL) ---------- */
    const endQ = getEnd(row);
    if (endQ && !checkQuarterValidation(endQ)) {
      row.endQtrErr = true;
      localErr.push({
        fieldName: keyFor('endQtr'),
        errorType: 'invalidQuarterFormat',
        message: `${constantMessageData.CONTRACT_END_QUARTER_FORMAT_ERROR} #${
          rowIndex + 1
        }.`,
      });
      dispatch(setNewCmsMatRowData(newObj));
      dispatch(handleErrorMessages(dedupeErrors(localErr)));
      return;
    }

    /* ---------- SPEC / GEN RULE ---------- */
    const hasSpec = !!row.specTheraCode;
    const hasGen = !!row.genCodeNum;

    if (!hasSpec && !hasGen) {
      row.specTheraCodeErr = true;
      row.genCodeNumErr = true;
      localErr.push({
        fieldName: keyFor('specTheraCode'),
        errorType: 'SPEC_OR_GEN_CODE_REQUIRED',
        message: `${SPEC_OR_GEN_CODE_REQUIRED} #${rowIndex + 1}.`,
      });
      dispatch(setNewCmsMatRowData(newObj));
      dispatch(handleErrorMessages(dedupeErrors(localErr)));
      return;
    }

    if (hasSpec && hasGen) {
      row.specTheraCodeErr = true;
      row.genCodeNumErr = true;
      localErr.push({
        fieldName: keyFor('specTheraCode'),
        errorType: 'BOTH_CODE_ERR',
        message: `${BOTH_CODE_ERR} #${rowIndex + 1}.`,
      });
      dispatch(setNewCmsMatRowData(newObj));
      dispatch(handleErrorMessages(dedupeErrors(localErr)));
      return;
    }

    /* ---------- DUPLICATE CHECK (FINAL RULE) ---------- */
    const hasDuplicate = newObj.some((x, i) => {
      if (i === rowIndex) return false;
      if (x?.isRemovedFromList) return false;

      const sameStart =
        getStart(x) &&
        checkQuarterValidation(getStart(x)) &&
        getStart(x) === startQ;

      if (!sameStart) return false;

      if (hasGen) return normalize(x.genCodeNum) === normalize(row.genCodeNum);

      if (hasSpec)
        return normalize(x.specTheraCode) === normalize(row.specTheraCode);

      return false;
    });

    if (hasDuplicate) {
      if (hasGen) row.genCodeNumErr = true;
      if (hasSpec) row.specTheraCodeErr = true;

      localErr.push({
        fieldName: hasGen ? keyFor('genCodeNum') : keyFor('specTheraCode'),
        errorType: 'DUP_CODE',
        message: `${DUP_CODE} #${rowIndex + 1}.`,
      });

      dispatch(setNewCmsMatRowData(newObj));
      dispatch(handleErrorMessages(dedupeErrors(localErr)));
      return;
    }

    /* ---------- SUCCESS ---------- */
    dispatch(setNewCmsMatRowData(newObj));
    dispatch(handleErrorMessages(dedupeErrors(localErr)));
  };

  if (colId === 'specTheraCode') {
    return (
      <>
        <label className="m-0 visually-hidden" htmlFor={id}>
          <span>{label}</span>{' '}
        </label>
        <div data-testid={`specTheraCode${rowIndex}`}>
          <TextField
            id={id}
            fullWidth
            placeholder=""
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ maxLength: 10, readOnly: isEnablebyRole }}
            value={data?.specTheraCode}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => handleOnBlurEvent(e.target.value)}
            disabled={data?.disableSpecTheraCode || false}
            className={
              resultData[rowIndex]?.specTheraCodeErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
            }
            aria-label={ariaLabel}
          />
        </div>
      </>
    );
  }
  if (colId === 'genCodeNum') {
    return (
      <>
        <label className="m-0 visually-hidden" htmlFor={id}>
          <span>{label}</span>{' '}
        </label>
        <div data-testid={`genCodeNum${rowIndex}`}>
          <TextField
            id={id}
            fullWidth
            placeholder=""
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ maxLength: 5, readOnly: isEnablebyRole }}
            value={data?.genCodeNum}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => handleOnBlurEvent(e.target.value)}
            disabled={data?.disableGenCodeNum || false}
            className={
              resultData[rowIndex]?.genCodeNumErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
            }
            onKeyDown={(e) => {
              // if ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight') {
              //   props.addAction(e, editedData, resultData);
              // }
            }}
            aria-label={ariaLabel}
          />
        </div>
      </>
    );
  }
};
